import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { MDBTable } from "mdbreact";
import { fullName, getAge, Banner } from "../../../services/utilities";
import Months from "../../../services/fakeDb/calendar/months";
import {
  BROWSE,
  RESET,
} from "../../../services/redux/slices/diagnostics/laboratory/chemistry.js";
import "./table.css";

const dayNames = [
  "Sunday",
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
];

const addZero = (i) => (i < 10 ? "0" + i : i);
const formatTime = (hours, minutes) => {
  let period = "AM";
  if (hours >= 12) {
    period = "PM";
    hours = hours > 12 ? hours - 12 : hours;
  } else if (hours === 0) {
    hours = 12;
  }
  return `${addZero(hours)}:${addZero(minutes)} ${period}`;
};

export default function ChemsPrint() {
  const [chems, setChems] = useState([]),
    { collections } = useSelector(({ chemistry }) => chemistry),
    { token, activePlatform } = useSelector(({ auth }) => auth),
    [month, setMonth] = useState(""),
    [year, setYear] = useState(""),
    dispatch = useDispatch();

  useEffect(() => {
    const _month = JSON.parse(localStorage.getItem("month"));
    const _year = JSON.parse(localStorage.getItem("year"));
    if (token && activePlatform?.branchId) {
      dispatch(
        BROWSE({
          entity: "results/laboratory/chemistry/logbook",
          data: {
            branch: activePlatform?.branchId,
            month: _month,
            year: _year,
          },
          token,
        })
      );
    }
    setMonth(_month);
    setYear(_year);
    return () => RESET();
  }, [activePlatform, dispatch, token, month, year]);

  useEffect(() => {
    setChems(collections);
  }, [collections]);

  const groupByDay = (chemistryData) =>
    chemistryData.reduce((acc, chem) => {
      const createdAt = new Date(chem.createdAt);
      const day = createdAt.getDate();
      if (!acc[day]) acc[day] = [];
      acc[day].push(chem);
      return acc;
    }, {});

  const groupedChems = groupByDay(chems);

  const renderGroupedChems = () => {
    return Object.keys(groupedChems).map((day) => {
      const sampleChem = groupedChems[day][0];
      const d = new Date(sampleChem.createdAt);
      const dayOfWeek = dayNames[d.getDay()];

      return (
        <React.Fragment key={day}>
          <tr>
            <td colSpan="15">
              <strong>
                {dayOfWeek} ({day})
              </strong>
            </td>
          </tr>
          {groupedChems[day].map((chem, index) => {
            const { customerId, packages, createdAt } = chem;
            const chemDate = new Date(createdAt);
            const h = chemDate.getHours();
            const m = chemDate.getMinutes();
            const timeFormatted = formatTime(h, m);

            return (
              <tr key={chem._id}>
                <td>{index + 1}</td>
                <td>
                  <span style={{ whiteSpace: "nowrap" }}>
                    {fullName(customerId.fullName)}
                  </span>
                  <span>
                    {getAge(customerId?.dob)}|
                    {customerId?.isMale ? "M" : "F"}
                  </span>
                </td>
                <td>{timeFormatted}</td>
                <td>{packages["9"]}</td>
                <td>{packages["10"]}</td>
                <td>{packages["12"]}</td>
                <td>{packages["13"]}</td>
                <td>{packages["14"]}</td>
                <td>{packages["15"]}</td>
                <td>{packages["16"]}</td>
                <td>
                  {packages["17"] ? Number(packages["17"]).toFixed(2) : ""}
                </td>
                <td>{packages["21"]}</td>
                <td>{packages["20"]}</td>
                <td>{packages["22"]}</td>
                <td></td>
              </tr>
            );
          })}
        </React.Fragment>
      );
    });
  };

  return (
    <div>
      <Banner
        company={activePlatform?.branch?.companyId?.name}
        branch={activePlatform?.branch?.name}
        className="banner"
      />

      <h3 className="text-center">
        Chemistry Report for {Months[month - 1]} {year}
      </h3>

      <MDBTable className="responsive logbooks-table">
        <thead>
          <tr>
            <th>#</th>
            <th>Name</th>
            <th>Time</th>
            <th>RBS</th>
            <th>FBS</th>
            <th>SGPT</th>
            <th>SGOT</th>
            <th>Chole</th>
            <th>Trigly</th>
            <th>HDL</th>
            <th>LDL</th>
            <th>BUN</th>
            <th>CREA</th>
            <th>BUA</th>
            <th>Remarks</th>
          </tr>
        </thead>
        <tbody>{renderGroupedChems()}</tbody>
      </MDBTable>

      <style>{`
        @media print {
          @page {
            size: A4 landscape;
            margin: 6mm;
          }

          .logbooks-table {
            width: 100%;
            border-collapse: collapse;
          }

          .logbooks-table tr th,
          .logbooks-table tr td {
            font-size: 12px !important;
            padding: 1px 3px !important;
          }

          .logbooks-table tr {
            page-break-inside: avoid;
          }
        }
      `}</style>
    </div>
  );
}
